(function () {
  const DIALOG_SEL = 'dialog.popup-link__content.dialog-modal';
  const TEXTAREA_SEL = 'textarea.contact-form__input--textarea';

  function clampTextarea(textarea) {
    const dialog = textarea.closest(DIALOG_SEL);
    if (!dialog) return;

    // Make sure layout is up to date
    const dialogRect = dialog.getBoundingClientRect();
    const taRect = textarea.getBoundingClientRect();

    // Space available from textarea top to dialog bottom, minus padding
    const available = Math.max(20, Math.floor(dialogRect.bottom - taRect.top - 16));

    // Apply cap
    textarea.style.maxHeight = available + 'px';
  }

  function wireTextarea(textarea) {
    if (textarea.dataset.clamped === '1') return;
    textarea.dataset.clamped = '1';

    // Initial clamp
    clampTextarea(textarea);

    // When user drags the resize handle, mouseup happens after resize
    textarea.addEventListener('mouseup', () => clampTextarea(textarea));
    textarea.addEventListener('touchend', () => clampTextarea(textarea));

    // If content changes and affects layout
    textarea.addEventListener('input', () => clampTextarea(textarea));

    // If the viewport changes
    window.addEventListener('resize', () => clampTextarea(textarea));
  }

  function setupForOpenDialogs() {
    document.querySelectorAll(`${DIALOG_SEL}[open] ${TEXTAREA_SEL}`).forEach(wireTextarea);
  }

  // Theme dispatches this event when opening dialogs (from dialog.js)
  document.addEventListener('dialog:open', () => {
    // Wait a tick to ensure the dialog is painted and sizes are correct
    requestAnimationFrame(setupForOpenDialogs);
  });

  // Fallback in case the dialog is already open or event doesn’t fire
  document.addEventListener('DOMContentLoaded', setupForOpenDialogs);
})();

